import { render, staticRenderFns } from "./InspectionDamages.vue?vue&type=template&id=b6050ef0&scoped=true&"
import script from "./InspectionDamages.vue?vue&type=script&lang=ts&"
export * from "./InspectionDamages.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionDamages.vue?vue&type=style&index=0&id=b6050ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6050ef0",
  null
  
)

export default component.exports